const formatNum = (number) => new Intl.NumberFormat("de-DE").format(number);

export default formatNum;
